// useIsMobile.js - returns true when the viewport is ≤480px (matches Layout.css mobile breakpoint)
// Uses matchMedia so it reacts to orientation changes without polling.

import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 480;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    // Sync immediately in case the value changed between render and effect
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
